@if (total === 0 && searchHasRun) {
  <div
    class="text-center d-flex flex-column my-5">
    <div class="no-results mx-auto mb-4"></div>
    <div class="display-5 mb-3 fw-lighter">Oops! No hits found.</div>
    <div>Try searching for a different keyword</div>
  </div>
}
@if (total > 0) {
  <div
    class="text-muted my-3">
    {total, plural, =1 {1 hit} =10000 {10,000+ hits} other { {{ total | number }} hits}}
    <ng-container> in {{ tab?.name }}</ng-container>
  </div>
}
